module.exports = __webpack_public_path__ + "img/maarten.15b00484.jpg";